import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CourseService } from '../../../service/course.service';
import { ModuloService } from '../../../service/modulo.service';
import { Corso } from '../../../model/corso';
import { first } from 'rxjs/operators';
import { CorsoModulo } from 'src/app/model/corsomodulo';

@Component({
  selector: 'app-esercitazioni-corso',
  templateUrl: './esercitazioni-corso.component.html',
  styleUrls: ['./esercitazioni-corso.component.css']
})
export class EsercitazioniCorsoComponent implements OnInit {

    corso: Corso;
    moduli: Array<CorsoModulo>;
    checkEsercitazioni = false;

    constructor(
        private route: ActivatedRoute,
        private courseSrv: CourseService,
        private moduloSrv: ModuloService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params =>  {
            this.loadCorso(+params.get('courseId'));
            this.loadModuliWithEsercitazioni(+params.get('courseId'));
        });
    }

    private loadCorso(courseId: number) {
        this.courseSrv.getCourse(courseId)
        .pipe(first())
            .subscribe(
                data => {
                    this.corso = data;
                },
                error => {
                    return;
                }
            );
    }

    private loadModuliWithEsercitazioni(courseId: number) {
        this.moduloSrv.getModuliWithEsercitazioni(courseId)
        .pipe(first())
            .subscribe(
                data => {
                    this.moduli = data;
                    this.checkForEsercitazioni(this.moduli);
                },
                error => {
                    return;
                }
            );
    }

    private checkForEsercitazioni(moduli: Array<CorsoModulo>) {
        moduli.forEach(modulo => {
            if (modulo.esercitazioni != null && modulo.esercitazioni.length > 0) {
                this.checkEsercitazioni = true;
                return;
            }
        });

        this.checkEsercitazioni = false;
    }

}
